import React, { useState, useRef } from 'react';
import styles from './ActionMenu.module.scss';
import useOutsideClick from '../../../../../hooks/useOutsideClick';

const ActionMenu = ({ onViewDetails, onCloseTicket, isCloseable }) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);

    useOutsideClick(menuRef, () => {
        if (isOpen) {
            setIsOpen(false);
        }
    });

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className={styles.actionMenuContainer} ref={menuRef}>
            <button className={styles.menuButton} onClick={handleToggle}>
                <i className="material-icons">more_vert</i>
            </button>
            {isOpen && (
                <div className={styles.dropdownMenu}>
                    <ul>
                        <li onClick={onViewDetails}>
                            <i className="material-icons">visibility</i>
                            <span>View Details</span>
                        </li>
                        {isCloseable && (
                            <li onClick={onCloseTicket}>
                                <i className="material-icons">close</i>
                                <span>Close Ticket</span>
                            </li>
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default ActionMenu;